import utils from '../../utils'

const BLK_HEAD_SIZE = 19;       // 数据块头大小
const BLK_TAIL_SIZE = 0;        // 数据块尾大小
const BLK_ID_KEY = 0x01;        // Key 块的类型
const BLK_ID_DATA = 0x02;       // Msg 块的类型
const BLK_TYPE_ANY = 0x00;      // 任意类型
const BLK_TYPE_STRING = 0x01;   // 字符串类型
const BLK_TYPE_BINARY = 0x02;   // 二进制类型
const BLK_TYPE_EVENT = 0x03;    // 来自事件服务的数据
const BLK_TYPE_SECRET = 0x04;   // 安全相关
const BLK_ZIP_NONE = 0x00;      // 未压缩
const BLK_ZIP_DEFLATE = 0x01;   // DEFLATE 压缩

const Block = function(opts = {}) {
    this.id         = opts.id         || BLK_ID_DATA;      // 块 ID （4字节）
    this.dataSize   = opts.dataSize   || 0;                // 数据长度（4字节）
    this.dataType   = opts.dataType   || BLK_TYPE_BINARY;  // 数据类型 （2字节）
    this.zipMethod  = opts.zipMethod  || BLK_ZIP_NONE;     // 压缩方式（1字节）：0 - 无压缩; 1 - deflate 压缩
    this.refId      = opts.refId      || 0;                // 引用的块 ID (备用)（4字节）
    this.reserv     = opts.reserv     || 0;                // 保留位（4字节）
    this.data       = opts.data       || [];               // 块数据
};

Block.BLK_HEAD_SIZE   = BLK_HEAD_SIZE;
Block.BLK_TAIL_SIZE   = BLK_TAIL_SIZE;
Block.BLK_ID_KEY      = BLK_ID_KEY;
Block.BLK_ID_DATA     = BLK_ID_DATA;
Block.BLK_TYPE_ANY    = BLK_TYPE_ANY;
Block.BLK_TYPE_STRING = BLK_TYPE_STRING;
Block.BLK_TYPE_BINARY = BLK_TYPE_BINARY;
Block.BLK_TYPE_EVENT  = BLK_TYPE_EVENT;
Block.BLK_TYPE_SECRET = BLK_TYPE_SECRET;
Block.BLK_ZIP_NONE    = BLK_ZIP_NONE;
Block.BLK_ZIP_DEFLATE = BLK_ZIP_DEFLATE;

const pt = Block.prototype;

// 整个块的大小
Object.defineProperty(pt, "blockSize", {
    configurable: false,
    enumerable: false,
    get() {
        return BLK_HEAD_SIZE + BLK_TAIL_SIZE + this.dataSize;
    }
});

Object.defineProperty(pt, "text", {
    configurable: false,
    enumerable: false,
    get() {
        if (this.data && this.data.length > 0) {
            return utils.utf8ByteArrayToString(this.data);
        }
        return '';
    }
});

pt.getDataTypeName = function (dataType) {
    if (typeof dataType == 'undefined') {
        dataType = this.dataType;
    }
    switch(dataType) {
        case BLK_TYPE_ANY: return 'any';
        case BLK_TYPE_STRING: return 'string';
        case BLK_TYPE_BINARY: return 'binary';
        default: return 'unknown';
    }
};

pt.toJSON = function() {
    var text = this.text;
    if (text) {
        return JSON.parse(text);
    }
    return null;
};

// 写入数据块
pt.writeBlock = function(writer) {
    writer.writeInt32(this.id);
    writer.writeInt32(this.dataSize);
    writer.writeInt16(this.dataType);
    writer.writeInt8 (this.zipMethod);
    writer.writeInt32(this.refId);
    writer.writeInt32(this.reserv);
    if (this.dataSize > 0)
    {
        writer.writeArrayBufferOrByteArray(this.data, 0, this.dataSize);
    }
};

pt.readBlock = function (reader) {
    let block = this;
    block.id = reader.readInt32();
    block.dataSize = reader.readInt32();
    block.dataType = reader.readInt16();
    block.zipMethod = reader.readInt8();
    block.refId = reader.readInt32();
    block.reserv = reader.readInt32();
    block.data = [];
    if (block.dataSize > 0) {
        block.data.length = block.dataSize;
        reader.readBuffer(block.data, 0, block.dataSize);
    }
    if (block.zipMethod == BLK_ZIP_DEFLATE && block.dataSize > 0) {
        block.data = utils.zip_inflate(block.data);
        block.zipMethod = BLK_ZIP_NONE;
        block.dataSize = block.data.length;
    }
};

Block.parseFromReader = function (reader) {
    var block = new Block();
    block.readBlock(reader);
    return block;
};

Block.wrap = function (data, zipMethod) {
    let array;
    if (typeof data === 'string') {
        array = utils.stringToUtf8ByteArray(data);
    }
    else if (data instanceof ArrayBuffer) {
        array = new Uint8Array(data);
    }
    else if (utils.isArray(data) || (typeof data.length !== 'undefined')) {
        array = data;
    }
    else if (data) {
        //throw new Error('"data" should be an ArrayBuffer or ByteArray');
        const s = JSON.stringify(data);
        array = utils.stringToUtf8ByteArray(s) || [];
    }
    else {
        array = [];
    }
    // 默认启用压缩
    if (typeof zipMethod === 'undefined') {
        zipMethod = Block.BLK_ZIP_DEFLATE;
    }
    if (zipMethod && array.length >= 16) {
         array = utils.zip_deflate(array);
         zipMethod = Block.BLK_ZIP_DEFLATE;
    }
    else {
        zipMethod = Block.BLK_ZIP_NONE;
    }
    var blk = new Block({
        id:        Block.BLK_ID_DATA,
        dataSize:  array.length,
        dataType:  Block.BLK_TYPE_BINARY,
        zipMethod: zipMethod,
        refId:     0x00,
        reserv:    0x00,
        data:      array
    });
    return blk;
};

export default Block;
